import React, { useEffect } from 'react';
import styled from 'styled-components';

export const FixedWrapper = styled.div`
    position: fixed;
    background: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10000;
`;

const Success = () => {
    useEffect(() => {
        let message = JSON.stringify({
            type: 'custom-event',
            status: 'success',
            url: window.location.href,
        });
        window.parent.postMessage(message, '*');
    }, []);

    return <FixedWrapper />;
};

export default Success;
